/**
* 提单错误码弹窗 BI 打点（仅 SUBMIT_ERROR_CONFIG 已配置错误码）
*/
import { pushTrackEvent } from '@utiles/officialTopupNew/trackEvent';
/**
 * @param {{
 *   code?: string|number,
 *   fPayType?: string,
 *   payType?: string,
 * }} params
 */
export function trackSubmitErrorPopupShow(params = {}) {
  try {
    const { code, fPayType = '', payType = '' } = params;
    pushTrackEvent({
      eventName: 'submit_error_popup',
      eventType: 'submit_error',
      eventValue: {
        code: code != null && code !== '' ? +code : '',
        f_pay_type: fPayType,
        pay_type: payType,
      },
    });
  } catch (e) {
    // 打点失败不影响主流程
  }
}

/**
 * @param {{
 *   code?: string|number,
 *   fPayType?: string,
 *   payType?: string,
 *   buttonAction?: string,
 *   buttonSlot?: 'confirm' | 'cancel',
 * }} params
 */
export function trackSubmitErrorButtonClick(params = {}) {
  try {
    const {
      code,
      fPayType = '',
      payType = '',
      buttonAction = '',
      buttonSlot = '',
    } = params;
    pushTrackEvent({
      eventName: 'submit_error_btn_click',
      eventType: 'submit_error',
      eventValue: {
        code: code != null && code !== '' ? +code : '',
        f_pay_type: fPayType,
        pay_type: payType,
        buttonAction,
        buttonSlot,
      },
    });
  } catch (e) {
    // 打点失败不影响主流程
  }
}
